import React from "react";
import { Col, Row } from "antd";
import { PopularCategory } from "../PopularCategory";
import styles from "./popularMobile.scss";

const PopularMobile = ({ populars }) => (
  <div>
    <Row className={styles.row} gutter={16}>
      <Col span={12}>
        <PopularCategory popular={populars[0]} />
      </Col>
      <Col span={12}>
        <PopularCategory popular={populars[1]} />
      </Col>
    </Row>

    <Row className={styles.row} gutter={16}>
      <Col span={12}>
        <PopularCategory popular={populars[2]} />
      </Col>
      <Col span={12}>
        <PopularCategory popular={populars[3]} />
      </Col>
    </Row>

    <Row className={styles.row} gutter={16}>
      <Col span={12}>
        <PopularCategory popular={populars[4]} />
      </Col>
      <Col span={12}>
        <PopularCategory popular={populars[5]} />
      </Col>
    </Row>
  </div>
);

export default PopularMobile;



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularMobile/PopularMobile.tsx